import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Logo, SectionLabel } from "@/components/bits";
import { BANNER } from "@/lib/images";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const redirect = loc.state?.from || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav(redirect);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      <div className="relative hidden lg:block">
        <img src={BANNER} alt="" className="absolute inset-0 h-full w-full object-cover grayscale-img" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative h-full flex flex-col justify-between p-14">
          <Logo size={44} />
          <div>
            <h2 className="font-display text-5xl uppercase leading-[0.9]">Undetected.<br />Undefeated.</h2>
            <p className="mt-4 max-w-sm text-white/50">Log in to access your license keys, order history and creator earnings.</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-5 py-24">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-10"><Logo size={40} /></div>
          <SectionLabel>ACCESS TERMINAL</SectionLabel>
          <h1 className="mt-4 font-display text-4xl uppercase">Log In</h1>

          {err && <div className="mt-6 rounded-xl border border-white/30 bg-white/[0.05] px-4 py-3 text-sm text-white/80" data-testid="login-error">{err}</div>}

          <div className="mt-8 space-y-5">
            <div>
              <label className="font-mono text-[10px] tracking-[0.2em] text-white/40">EMAIL</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3.5 text-sm focus:border-white focus:outline-none" />
            </div>
            <div>
              <label className="font-mono text-[10px] tracking-[0.2em] text-white/40">PASSWORD</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3.5 text-sm focus:border-white focus:outline-none" />
            </div>
          </div>

          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-inj mt-8 w-full py-4 text-sm flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <><Loader2 size={16} className="animate-spin" /> AUTHENTICATING</> : "LOG IN"}
          </button>

          <p className="mt-6 text-center text-sm text-white/50">
            No account? <Link to="/register" className="text-white underline" data-testid="to-register-link">Create one</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
